<div class="text-center flex flex-col justify-center border border-gray-400 p-3 rounded-xl border-dashed w-full h-full">
  <div class="mb-1">
    <mat-icon class="material-icons-outlined text-4xl !h-[32px] !w-[32px]">{{ icon }}</mat-icon>
  </div>
  <h1 class="text-gray-700 font-semibold text-2xl">{{ headerText }}</h1>
  <p class="text-gray-500 font-medium" [innerHTML]="paraText"></p>
</div>
